import React from 'react'

interface OrderCardSkeletonProps {
  className?: string
}

const OrderCardSkeleton: React.FC<OrderCardSkeletonProps> = ({ className = '' }) => {
  return (
    <div
      className={`p-4 bg-white rounded-2xl flex flex-col gap-4 ${className}`}
    >
      {/* Header: Status and Customer */}
      <div className={`flex justify-between items-center flex-row-reverse`}>
        {/* Status Badge Skeleton */}
        <div className="px-2 py-0.5 bg-neutral-100 rounded-lg flex items-center gap-1 flex-row-reverse">
          <div className="h-4 w-12 shimmer rounded"></div>
          <div className="w-3.5 h-3.5 shimmer rounded"></div>
        </div>

        {/* Customer Info Skeleton */}
        <div className={`flex-1 flex items-center gap-3 flex-row-reverse`}>
          <div className={`flex-1 flex flex-col gap-1 items-start`}>
            <div className="h-5 w-32 shimmer rounded"></div>
            <div className="h-4 w-24 shimmer rounded"></div>
          </div>
          <div className="w-10 h-10 shimmer rounded-lg"></div>
        </div>
      </div>

      {/* Order Details Tags Skeleton */}
      <div className={`flex items-start gap-2 flex-wrap justify-start`}>
        {[1, 2, 3, 4].map((index) => (
          <div
            key={index}
            className={`px-1.5 py-1 bg-neutral-100 rounded-lg flex items-center gap-2 flex-row-reverse`}
          >
            <div className="h-3 w-16 shimmer rounded"></div>
          </div>
        ))}
      </div>

      {/* Divider */}
      <div className="h-px bg-border-soft" />

      {/* Total Skeleton */}
      <div className={`flex items-start gap-1 flex-row-reverse justify-between`}>
        <div className={`flex-1 flex items-center gap-1 flex-row-reverse`}>
          <div className="w-4 h-4 shimmer rounded"></div>
          <div className="h-5 w-20 shimmer rounded"></div>
        </div>
        <div className="h-5 w-12 shimmer rounded"></div>
      </div>
    </div>
  )
}

export default OrderCardSkeleton

